import React from 'react';
import { PropTypes, describe } from 'react-desc';
import moment from 'moment';
import TimePickerImpl from './TimePickerImpl.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'prop-types';
import 'memoize-one';
import '@elliemae/ds-utilities/timeUtils';
import '@elliemae/ds-classnames';
import '@elliemae/ds-form/InputGroup';
import '@elliemae/ds-form/TimeInput';
import '@elliemae/ds-form/Input';
import './TimePickerMenu.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import './utils.js';
import './PickerPanel.js';
import '@babel/runtime/helpers/esm/toArray';
import 'lodash';
import '@elliemae/ds-icons/ChevronSmallUp';
import '@elliemae/ds-icons/ChevronSmallDown';
import '@elliemae/ds-button';
import './moveElementOnScroll.js';
import './TimePickerDropdown.js';
import '@elliemae/ds-icons/RecentDocuments';
import '@elliemae/ds-popper';

var DSTimePicker = function DSTimePicker(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      innerRef = _ref.innerRef,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      format = _ref.format,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? function () {
    return null;
  } : _ref$onOpen,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? undefined : _ref$isOpen,
      _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === void 0 ? false : _ref$clearable,
      _ref$hasHeader = _ref.hasHeader,
      hasHeader = _ref$hasHeader === void 0 ? true : _ref$hasHeader,
      _ref$hasHeaderDisplay = _ref.hasHeaderDisplay,
      hasHeaderDisplay = _ref$hasHeaderDisplay === void 0 ? false : _ref$hasHeaderDisplay,
      ariaLabel = _ref['aria-label'],
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 'auto' : _ref$zIndex,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      disabledTimes = _ref.disabledTimes,
      _ref$minutesInterval = _ref.minutesInterval,
      minutesInterval = _ref$minutesInterval === void 0 ? 1 : _ref$minutesInterval;
  return /*#__PURE__*/React.createElement(TimePickerImpl, {
    ref: innerRef,
    "aria-label": ariaLabel,
    className: className,
    clearable: clearable,
    containerProps: containerProps,
    disabled: disabled,
    format: format,
    hasHeader: hasHeader,
    hasHeaderDisplay: hasHeaderDisplay,
    isOpen: isOpen,
    onChange: onChange,
    onOpen: onOpen,
    placement: placement,
    style: style,
    value: value,
    zIndex: zIndex,
    minutesInterval: minutesInterval,
    disabledTimes: disabledTimes
  });
};

DSTimePicker.defaultProps = {
  format: 'hh:mm:ss A'
};
var props = {
  /** a11y label */
  'aria-label': PropTypes.string.description('a11y label'),

  /** inject props to time picker wrapper */
  containerProps: PropTypes.object.description('inject props to time picker wrapper'),

  /** Whether the time picker is disabled or not */
  disabled: PropTypes.bool.description('Whether the time picker is disabled or not'),

  /** Time picker value */
  value: PropTypes.instanceOf(moment).description('Time picker value'),

  /** Time format (hh:mm:ss, H:m:s) */
  format: PropTypes.string.description('Time format (hh:mm:ss, H:m:s)'),

  /** toggle header style */
  hasHeader: PropTypes.bool.description('toggle header style'),

  /** toggle header display */
  hasHeaderDisplay: PropTypes.bool.description('toggle header display'),

  /** Handler when time picker value changes */
  onChange: PropTypes.func.description('Handler when time picker value changes'),

  /** Handler when the time picker menu opens */
  onOpen: PropTypes.func.description('Handler when the time picker menu opens'),

  /** Whether the time picker menu is opened or not */
  isOpen: PropTypes.bool.description('Whether the time picker menu is opened or not'),

  /** ref for time picker input */
  innerRef: PropTypes.func.description('ref for time picker input'),

  /** Enable to clear the time picker value */
  clearable: PropTypes.bool.description('Enable to clear the time picker value'),

  /** class for time picker */
  className: PropTypes.string.description('class for time picker'),

  /** style object */
  style: PropTypes.object.description('style object'),

  /** z index for menu */
  zIndex: PropTypes.number.description('z index for menu'),

  /** DSPopper placement */
  placement: PropTypes.string.description('DSPopper placement'),

  /** disabled time */
  disabledTimes: PropTypes.object.description('disabled time'),

  /** steps for the picker */
  minutesInterval: PropTypes.number.description('steps for the picker')
};
DSTimePicker.propTypes = props;
var DSTimePickerWithSchema = describe(DSTimePicker);
DSTimePickerWithSchema.propTypes = props;

export default DSTimePicker;
export { DSTimePicker, DSTimePickerWithSchema };
//# sourceMappingURL=DSTimePicker.js.map
